import React, { useRef, useEffect, useCallback, useState} from 'react';
import Sample from 'repos/Sample.js';
import AudioUnit from 'engine/audio.js';
import {connect} from 'react-redux';
import Waveform from 'components/Waveform.js';

const ConvolverWaveform = ({effect, convolverSample, pitch, duration, attack}) => { 
    let counter = useRef(0);
    let [id, setId] = useState(convolverSample + pitch + duration + attack);
    let [audioUnit, setAudioUnit] = useState(new AudioUnit());

    useEffect(() => {
        counter.current = counter.current + 1;
        let c = counter.current;
        setTimeout(() => {
            console.log("c = %s counter=%s", c, counter.current);
            if (c === counter.current && effect.effectNode.buffer) {
                console.log('setting buffer =', effect.effectNode.buffer._buffer);
                setId(convolverSample + duration + pitch + attack + c);
            }
        }, 100);
    }, [convolverSample, setId, effect.effectNode.buffer, pitch, duration, attack]);

    audioUnit.setBuffer(effect.effectNode.buffer._buffer);
    let sample = new Sample(id);
    return (
        <Waveform
          audioUnit={audioUnit}
          sequencerEngine={effect.sequencerEngine}
          buffer={effect.effectNode.buffer}
          id={id}
          sample={sample}
          width={180}
          height={30}/>
 
    );
}

const mapStateToProps = (state, props) => {
  return {
      convolverSample: props.effect.convolverSample,
      buffer: props.effect.effectNode.buffer,
      pitch: props.effect.pitch,
      attack: props.effect.attack,
      duration: props.effect.duration,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ConvolverWaveform);
